// dialogSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { slice } from "../../../enums";
import { IIcdTreeProps } from "../../../interfaces";

 
interface IcdTreeState extends IIcdTreeProps {
    isOpen: boolean;

    displayTreeAs: 'modal'  | 'page'
}

/**
 *
 */
const initialState: IcdTreeState = {
    isOpen: false,

    displayTreeAs: 'modal'
};

const icdTreeSlice = createSlice({
    name: slice.ALERT,
    initialState,
    reducers: {
        openIcdTreeAs: (state, action: PayloadAction<'modal' | 'page'>) => {
            state.displayTreeAs = action.payload;

            state.isOpen = !state.isOpen;
        },
        closeIcdTree: (state) => {
            
            state.isOpen = false;
            state.displayTreeAs = "modal";
        },
    },
});

export const { openIcdTreeAs,closeIcdTree } = icdTreeSlice.actions;

export default icdTreeSlice.reducer;
